import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Menu, TextField, Tooltip } from '@material-ui/core';
import FilterVariantIcon from 'mdi-react/FilterVariantIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import isEqual from 'lodash/isEqual';

var GridToolbarFilters =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridToolbarFilters, _React$Component);

  function GridToolbarFilters() {
    var _this;

    _classCallCheck(this, GridToolbarFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridToolbarFilters).apply(this, arguments));
    _this.state = {
      open: null,
      modal: false,
      input: ''
    };

    _this.openMenu = function (event) {
      _this.setState({
        open: event.currentTarget
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        open: null
      });
    };

    _this.openModal = function () {
      _this.setState({
        modal: true
      });
    };

    _this.closeModal = function () {
      _this.setState({
        modal: false,
        input: ''
      });
    };

    _this.onChange = function (event) {
      _this.setState({
        input: event.target.value
      });
    };
    /**
     * Сохранить фильтр
     */


    _this.saveFilter = function () {
      var input = _this.state.input;
      var _this$props = _this.props,
          filter = _this$props.filter,
          listFilters = _this$props.listFilters,
          onChangeListFilters = _this$props.onChangeListFilters;
      listFilters.push({
        name: input,
        data: filter
      });
      onChangeListFilters(listFilters);

      _this.closeModal();
    };
    /**
     * Удалить фильтр
     * @param index
     */


    _this.deleteFilter = function (index) {
      return function () {
        var _this$props2 = _this.props,
            listFilters = _this$props2.listFilters,
            onChangeListFilters = _this$props2.onChangeListFilters;
        listFilters.splice(index, 1);
        onChangeListFilters(listFilters);
      };
    };

    _this.selectFilter = function (index) {
      return function () {
        var _this$props3 = _this.props,
            listFilters = _this$props3.listFilters,
            onChangeFilterFromStorage = _this$props3.onChangeFilterFromStorage;
        onChangeFilterFromStorage(listFilters[index].data);

        _this.closeMenu();
      };
    };

    _this.clearFilters = function () {
      _this.props.onChangeFilter(null);

      _this.closeMenu();
    };

    _this.isActive = function (item) {
      var filter = _this.props.filter;
      return isEqual(filter, item.data);
    };

    return _this;
  }

  _createClass(GridToolbarFilters, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          classes = _this$props4.classes,
          listFilters = _this$props4.listFilters;
      var _this$state = this.state,
          open = _this$state.open,
          modal = _this$state.modal,
          input = _this$state.input;
      return React.createElement(React.Fragment, null, React.createElement(Tooltip, {
        title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small',
        onClick: this.openMenu
      }, React.createElement(FilterVariantIcon, {
        size: 20
      }))), React.createElement(Menu, {
        anchorEl: open,
        open: Boolean(open),
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClose: this.closeMenu
      }, React.createElement("div", {
        className: classes.toolbarMenu
      }, React.createElement("div", {
        className: classes.toolbarMenuHead
      }, React.createElement("div", null, "\u041F\u0440\u0435\u0441\u0435\u0442\u044B \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432"), React.createElement(Tooltip, {
        title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarMenuHeadPlus,
        color: 'primary',
        onClick: this.openModal
      }, React.createElement(PlusIcon, {
        size: 18
      })))), React.createElement(List, null, !listFilters.length && React.createElement("div", {
        className: classes.toolbarMenuEmpty
      }, "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442"), listFilters.map(function (filter, index) {
        var active = _this2.isActive(filter);

        return React.createElement(ListItem, {
          button: true,
          key: "filter-".concat(index),
          onClick: _this2.selectFilter(index),
          dense: true,
          className: "".concat(active ? classes.toolbarMenuActive : '')
        }, React.createElement(ListItemText, {
          primary: filter.name
        }), React.createElement(ListItemSecondaryAction, null, React.createElement(IconButton, {
          onClick: _this2.deleteFilter(index),
          size: 'small',
          className: "".concat(classes.toolbarMenuIcon, " ").concat(active ? classes.toolbarMenuIconActive : '')
        }, React.createElement(DeleteOutlineIcon, {
          size: 18
        }))));
      })), React.createElement("div", {
        className: classes.toolbarMenuBoot
      }, React.createElement("div", {
        className: classes.toolbarMenuBootButton,
        onClick: this.clearFilters
      }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B")))), React.createElement(Dialog, {
        open: modal,
        onClose: this.closeModal,
        "aria-labelledby": 'form-dialog-title',
        fullWidth: true,
        maxWidth: 'xs'
      }, React.createElement(DialogTitle, {
        id: 'form-dialog-title'
      }, "\u041D\u043E\u0432\u044B\u0439 \u043F\u0440\u0435\u0441\u0435\u0442 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432"), React.createElement(DialogContent, null, React.createElement(TextField, {
        autoFocus: true,
        margin: 'dense',
        label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435",
        type: 'text',
        value: input || '',
        onChange: this.onChange,
        fullWidth: true
      })), React.createElement(DialogActions, {
        className: classes.modalActions
      }, React.createElement(Button, {
        onClick: this.closeModal,
        color: 'secondary',
        size: 'small'
      }, "\u041E\u0442\u043C\u0435\u043D\u0430"), React.createElement(Button, {
        onClick: this.saveFilter,
        color: 'primary',
        size: 'small',
        variant: 'contained',
        disabled: !input
      }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))));
    }
  }]);

  return GridToolbarFilters;
}(React.Component);

export default GridToolbarFilters;